import { Fancybox } from '@fancyapps/ui';

export default function initFB() {
  Fancybox.bind('[data-fancybox]', {
    tpl: {
      closeButton: `
      <button class="close absolute top-0 right-1 text-orange hover:text-dark w-6 h-6 m-2 lg:m-6 is-close-btn">
      <span class="sr-only">Close</span>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8112 26.8115C21.7022 26.8115 26.4779 22.0359 26.4779 16.1448C26.4779 10.2538 21.7022 5.47815 15.8112 5.47815C9.92016 5.47815 5.14453 10.2538 5.14453 16.1448C5.14453 22.0359 9.92016 26.8115 15.8112 26.8115Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.6677 19.2865L18.9531 13.0011M12.6677 13.0019L18.9531 19.2873" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg> </button>
        `,
    },
    Carousel: {
      Navigation: {
        prevTpl: `
            <span class="sr-only">Previous popup</span>
            <svg width="32" height="32" viewBox="0 0 32 32" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.6667" cy="10.6667" r="10.6667" transform="matrix(-1 0 0 1 26.666 5.33325)"  stroke-width="2"/>
<path d="M17.1348 12.1416L13.0497 15.7728L17.1348 19.404"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        `,
        nextTpl: `
            <span class="sr-only">Next popup</span>
            <svg width="32" height="32" viewBox="0 0 32 32" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.6667" cy="10.6667" r="10.6667" transform="matrix(-1 0 0 1 26.666 5.33325)"  stroke-width="2"/>
<path d="M14.8652 12.1416L18.9503 15.7728L14.8652 19.404" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        `,
      },
      on: {
        createSlide: (carousel, slide) => {
          if (slide.type === 'inline' && slide.el) {
            setTimeout(() => {
              slide.closeBtnEl.addEventListener('click', () => {
                Fancybox.close();
              });
            }, 50);
          }
          if (slide.type === 'image' && slide.el) {
            setTimeout(() => {
              const content = slide.el.querySelector('.fancybox__content');
              if (content && !content.querySelector('.bd-wrap')) {
                const wrapper = document.createElement('span');
                wrapper.classList.add('bd-wrap');
                content.appendChild(wrapper);
              }
              if (!content.querySelector('.fancybox-close-btn')) {
                const closeButton = document.createElement('button');
                closeButton.className = 'close absolute top-1 right-1 text-orange hover:text-dark w-8 h-8 m-2 fancybox-close-btn';
                closeButton.innerHTML = `
                  <span class="sr-only">Close</span>
                  <svg class="w-full h-full" stroke="currentColor" fill="none" viewBox="0 0 32 32">
<path d="M15.8112 26.8115C21.7022 26.8115 26.4779 22.0359 26.4779 16.1448C26.4779 10.2538 21.7022 5.47815 15.8112 5.47815C9.92016 5.47815 5.14453 10.2538 5.14453 16.1448C5.14453 22.0359 9.92016 26.8115 15.8112 26.8115Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.6677 19.2865L18.9531 13.0011M12.6677 13.0019L18.9531 19.2873" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                `;
                closeButton.addEventListener('click', () => {
                  Fancybox.close();
                });
                content.appendChild(closeButton);
              }
            }, 50);
          }

          setTimeout(() => {
            const closeButton2 = document.querySelector('.is-close-btn');
            if (closeButton2) {
              console.log(closeButton2);
              closeButton2.addEventListener('click', () => {
                Fancybox.close();
              });
            }
          }, 50);
        },
      },
    },
    Toolbar: {
      display: {
        left: ['prev'],
        middle: [],
        right: ['next', 'close'], // Ensure 'close' is included in the toolbar
      },
    },
    template: {
      close: `
        <button class="fancybox-button fancybox-button--close" title="Close">
          <span class="sr-only">Close</span>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8112 26.8115C21.7022 26.8115 26.4779 22.0359 26.4779 16.1448C26.4779 10.2538 21.7022 5.47815 15.8112 5.47815C9.92016 5.47815 5.14453 10.2538 5.14453 16.1448C5.14453 22.0359 9.92016 26.8115 15.8112 26.8115Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.6677 19.2865L18.9531 13.0011M12.6677 13.0019L18.9531 19.2873" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `,
    },
  });
}
